import passwordToggle from '../modules/passwordToggle';
import passwordStrength from '../modules/passwordStrength';

// Show/Hide password toggles
let passwordInputs = document.querySelectorAll('input[type=password]');
if (passwordInputs) {
	passwordInputs.forEach((input) => {
		let parent = input.parentNode;
		if (
			parent.classList.contains('field-wrap') &&
			parent.querySelector('button.toggle')
		) {
			parent
				.querySelector('button.toggle')
				.addEventListener('click', function (e) {
					passwordToggle(e);
				});
		}
	});
}

let passwordStrengthInput = document.querySelector(
	'input[type=password].password-strength'
);
if (passwordStrengthInput) {
	passwordStrength(passwordStrengthInput);
}
